import globals from '../../globals';
import actionTypes from '../constants/action-types';

const pageHasGlobals = (state = {}, action) => {
  if (action.type !== actionTypes.SET_PAGE_HTML) return state;
  if (state.id !== action.payload.pageId) return state;

  return {
    ...state,
    hasGlobals: globals.verifiers.hasGlobals(action.payload.html),
  };
};

export default pageHasGlobals;
